
export const stomp = {
    namespaced: true,
    state: {
        connected:false
    },
    actions: {
        setConnectionStateAction({ commit }, value) {
            commit('setConnectionState', value);
        },
    },
    mutations: {
        setConnectionState(state, value) {
            state.connected = value;
        },
    },
    getters: {
        // Define the getter
        connectionState(state) {
            return state.connected;
        },
    },
};
